/**
 * Mirror report_sections.strip_inline_markdown_formatting for on-screen chat display.
 */
export function stripMarkdownForDisplay(text) {
  if (!text) return '';
  let cleaned = String(text);
  cleaned = cleaned.replace(/\*\*\*(.+?)\*\*\*/g, '$1');
  cleaned = cleaned.replace(/\*\*(.+?)\*\*/g, '$1');
  cleaned = cleaned.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '$1');
  cleaned = cleaned.replace(/^#{1,6}\s*$/gm, '');
  cleaned = cleaned.replace(/^#{1,6}(?=\S)/gm, '');
  cleaned = cleaned.replace(/^#{1,6}\s+/gm, '');
  cleaned = cleaned.replace(/^\*{3}\s*$/gm, '');
  cleaned = cleaned.replace(/^[-*•]\s+/gm, '');
  return cleaned.trim();
}

export function formatChatMessageForDisplay(message) {
  if (!message || message.role !== 'assistant') {
    return message?.content ?? '';
  }
  return stripMarkdownForDisplay(message.content);
}
